import styled from "styled-components";
import { theme } from "./colors";

/* Linha de chips com rolagem horizontal (arrastar com o dedo no celular) */
export const ChipRow = styled.div`
  display: flex;
  gap: 8px;
  overflow-x: auto;
  scroll-snap-type: x proximity;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Chip = styled.button<{ $active: boolean }>`
  flex-shrink: 0;
  scroll-snap-align: start;
  border: 1px solid
    ${({ $active }) => ($active ? theme.colors.base : "rgba(0, 0, 0, 0.08)")};
  background-color: ${({ $active }) =>
    $active ? theme.colors.base : "#ffffff"};
  color: ${({ $active }) => ($active ? "#ffffff" : "#555555")};
  border-radius: 999px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 700;
  font-family: inherit;
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    color 0.2s ease,
    border-color 0.2s ease,
    transform 0.15s ease;

  &:active {
    transform: scale(0.95);
  }
`;

// Centraliza o chip tocado na linha, para o selecionado nunca ficar escondido
export const revealChip = (chip: HTMLElement) =>
  chip.scrollIntoView?.({
    behavior: "smooth",
    inline: "center",
    block: "nearest",
  });
